import { Input, Select, Button, Form, Row, Col } from "antd";
import { FORMS, BUTTONS } from "../common/constants";
import { useRef, useState } from "react";

const CreateVehicleModelForm = ({ handleSubmit }) => {
  const vehicelModelFormRef = useRef(null);

  const { Option } = Select;

  const getFormFieldRule = (field, pattern, errorMessage) => [
    {
      required: true,
      message: `Please Enter ${field}!`,
    },
    {
      pattern,
      message: errorMessage,
    },
  ];

  const weightType = ["KG", "G"];
  const driveModeList = ["Eco", "City", "Power"];

  const formFields = [
    {
      label: FORMS.VEHICLE_MODEL.FIELDS.NAME.LABEL,
      name: FORMS.VEHICLE_MODEL.FIELDS.NAME.NAME,
      rules: getFormFieldRule(FORMS.VEHICLE_MODEL.FIELDS.NAME.LABEL),
      style: {},
    },
    {
      label: FORMS.VEHICLE_MODEL.FIELDS.GROSS_WEIGHT.LABEL,
      name: FORMS.VEHICLE_MODEL.FIELDS.GROSS_WEIGHT.NAME,
      rules: getFormFieldRule(FORMS.VEHICLE_MODEL.FIELDS.GROSS_WEIGHT.LABEL),
      style: {},
    },
    {
      label: FORMS.VEHICLE_MODEL.FIELDS.NET_WEIGHT.LABEL,
      name: FORMS.VEHICLE_MODEL.FIELDS.NET_WEIGHT.NAME,
      rules: getFormFieldRule(FORMS.VEHICLE_MODEL.FIELDS.NET_WEIGHT.LABEL),
      style: {},
    },
  ];

  const [modeFields, setModeFields] = useState([]);
  const driveModeUpdate = (value) => {
    setModeFields(value);
  };
  // const totalWeightUpdate = () => {
  //   const riderWeight = riderFormRef.current?.getFieldValue("riderWeight")
  //     ? Number(riderFormRef.current?.getFieldValue("riderWeight"))
  //     : 0;
  //   const extraWeight = riderFormRef.current?.getFieldValue(
  //     "pillionRiderWeight"
  //   )
  //     ? Number(riderFormRef.current?.getFieldValue("pillionRiderWeight"))
  //     : 0;
  //   riderFormRef.current?.setFieldsValue({
  //     totalWeight: vehicleDetails?.weight + riderWeight + extraWeight,
  //   });
  // };

  console.log(
    "tesaytdsas",
    FORMS.VEHICLE_MODEL.FIELDS.WEIGHT_TYPE.NAME,
    vehicelModelFormRef?.current?.getFieldValue(
      FORMS.VEHICLE_MODEL.FIELDS.WEIGHT_TYPE.NAME
    )
  );
  console.log(
    "tesaytdsas",
    FORMS.VEHICLE_MODEL.FIELDS.DRIVE_MODE.NAME,
    vehicelModelFormRef?.current?.getFieldValue(
      FORMS.VEHICLE_MODEL.FIELDS.DRIVE_MODE.NAME
    )
  );

  return (
    <Form
      ref={vehicelModelFormRef}
      onFinish={handleSubmit}
      autoComplete="off"
      className="mt2"
      initialValues={{
        [FORMS.VEHICLE_MODEL.FIELDS.DRIVE_MODE.NAME]: [],
      }}
    >
      {formFields.map((field, index) => (
        <Form.Item
          key={index}
          label={field.label}
          name={field.name}
          rules={field.rules}
          style={field.style}
          help={field.help}
        >
          <Input />
        </Form.Item>
      ))}

      <Form.Item
        name={FORMS.VEHICLE_MODEL.FIELDS.WEIGHT_TYPE.NAME}
        label={FORMS.VEHICLE_MODEL.FIELDS.WEIGHT_TYPE.LABEL}
        rules={getFormFieldRule(FORMS.VEHICLE_MODEL.FIELDS.WEIGHT_TYPE.LABEL)}
      >
        <Select
          allowClear
          placeholder={FORMS.VEHICLE_MODEL.FIELDS.WEIGHT_TYPE.PLACEHOLDER}
        >
          {weightType.map((type, index) => (
            <Option key={index} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name={FORMS.VEHICLE_MODEL.FIELDS.VARIANT.NAME}
        label={FORMS.VEHICLE_MODEL.FIELDS.VARIANT.LABEL}
        rules={getFormFieldRule(FORMS.VEHICLE_MODEL.FIELDS.VARIANT.LABEL)}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name={FORMS.VEHICLE_MODEL.FIELDS.DRIVE_MODE.NAME}
        label={FORMS.VEHICLE_MODEL.FIELDS.DRIVE_MODE.LABEL}
        // rules={getFormFieldRule(
        //   FORMS.VEHICLE_MODEL.FIELDS.DRIVE_MODE.LABEL
        // )}
      >
        <Select
          allowClear
          mode="multiple"
          maxTagCount={"responsive"}
          onChange={driveModeUpdate}
          placeholder={FORMS.VEHICLE_MODEL.FIELDS.DRIVE_MODE.PLACEHOLDER}
        >
          {driveModeList.map((data, index) => (
            <Option key={index} value={data}>
              {data}
            </Option>
          ))}
        </Select>
      </Form.Item>

      {modeFields.map((mode, index) => (
        <Form.Item key={index} label={mode} className="mb0 w100 mode-min-max">
          <Row>
            <Col span={12}>
              <Form.Item
                label={"Min"}
                name={mode + "Min"}
                // rules={getFormFieldRule(FORMS.VEHICLE_MODEL.FIELDS.MIN.LABEL)}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                key={index}
                label={"Max"}
                name={mode + "Max"}
                // rules={getFormFieldRule(FORMS.VEHICLE_MODEL.FIELDS.MIN.LABEL)}
              >
                <Input />
              </Form.Item>
            </Col>{" "}
          </Row>
        </Form.Item>
      ))}

      <Button type="primary" htmlType="submit">
        {BUTTONS.CREATE}
      </Button>
    </Form>
  );
};

export default CreateVehicleModelForm;
